import { io, Socket } from 'socket.io-client';

class SocketService {
  private socket: Socket | null = null;
  private isConnected = false;

  connect(token: string) {
    if (this.socket && this.isConnected) {
      return this.socket;
    }

    this.socket = io('/', {
      auth: { token },
      transports: ['websocket', 'polling'],
    });

    this.socket.on('connect', () => {
      console.log('Connected to WebSocket server');
      this.isConnected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket server');
      this.isConnected = false;
    });

    this.socket.on('connect_error', (error) => {
      console.error('WebSocket connection error:', error);
      this.isConnected = false;
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  getSocket(): Socket | null {
    return this.socket;
  }

  isSocketConnected(): boolean {
    return this.isConnected;
  }

  // Game update listeners
  onGameCreated(callback: (gameData: any) => void) {
    if (this.socket) {
      this.socket.on('gameCreated', callback);
    }
  }

  onGameUpdated(callback: (gameData: any) => void) {
    if (this.socket) {
      this.socket.on('gameUpdated', callback);
    }
  }

  onGameDeleted(callback: (gameId: string) => void) {
    if (this.socket) {
      this.socket.on('gameDeleted', callback);
    }
  }

  onGameJoined(callback: (gameData: any) => void) {
    if (this.socket) {
      this.socket.on('gameJoined', callback);
    }
  }

  onGameLeft(callback: (gameData: any) => void) {
    if (this.socket) {
      this.socket.on('gameLeft', callback);
    }
  }

  onGameStarted(callback: (gameData: any) => void) {
    if (this.socket) {
      this.socket.on('gameStarted', callback);
    }
  }

  // Remove listeners
  offGameCreated() {
    if (this.socket) {
      this.socket.off('gameCreated');
    }
  }

  offGameUpdated() {
    if (this.socket) {
      this.socket.off('gameUpdated');
    }
  }

  offGameDeleted() {
    if (this.socket) {
      this.socket.off('gameDeleted');
    }
  }

  offGameJoined() {
    if (this.socket) {
      this.socket.off('gameJoined');
    }
  }

  offGameLeft() {
    if (this.socket) {
      this.socket.off('gameLeft');
    }
  }

  offGameStarted() {
    if (this.socket) {
      this.socket.off('gameStarted');
    }
  }
}

export const socketService = new SocketService();
export default socketService; 